const policies = new Map();
// Default policy for scenes that don't register one:
// - No radius cap by default (infinite/disabled)
// - Keep your legacy floor behaviour as the default (floorY = 2)
export const DEFAULT_SCENE_POLICY = { radius: 20000 };
export function registerScenePolicy(name, policy) {
    policies.set(name, policy);
}
export function getScenePolicy(name) {
    return policies.get(name);
}
